import React from 'react';
import PropTypes from 'prop-types';
import { getRelativeDate } from '../../../../utils/datetime.js';
import { callExternalLinkHandler } from '../../utils.jsx';

class ItemDate extends React.Component {
  constructor(props) {
    super(props);
    this.handleClick = this.handleClick.bind(this);
  }
  handleClick(e, url) {
    // External link handler.
    callExternalLinkHandler(this.props.onExternalLinkClick, url, e);

    // don't open detail overlay
    e.stopPropagation();
  }
  render() {
    const dateString = getRelativeDate(this.props.date);
    if (this.props.link) {
      return (
        <a
          className="xMetaContainer xMetaDate"
          href={this.props.link}
          target="_blank"
          onClick={e => {
            this.handleClick(e, this.props.link);
          }}
        >
          <p className="xMeta xTimestamp xPublishDate">{dateString}</p>
        </a>
      );
    } else {
      return (
        <div className="xMetaContainer xMetaDate">
          <p className="xMeta xTimestamp xPublishDate">{dateString}</p>
        </div>
      );
    }
  }
}

ItemDate.propTypes = {
  date:                PropTypes.instanceOf(Date).isRequired,
  link:                PropTypes.string,
  onExternalLinkClick: PropTypes.func,
};

export default ItemDate;
